import React, { useCallback, useState } from "react";
import { Form, Button, Drawer } from "antd";
import { observer } from "mobx-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { vsmNotify } from "../../../../config/messages";
import useStore from "../../../../store";
import { addonNormalInsurance, convertError, tpInsurance } from '../../../../utils/GlobalFunction'
import InsuranceProductFormComponent from "./InsuranceProductFormComponent";
import { debounce } from "@syncfusion/ej2-base";

const AddComponent = observer((props) => {
	const { openSelectAddOnModal } = props;
	const [form] = Form.useForm();
	const [saving, setSaving] = useState();

	const {
		InsuranceProductStore,
	} = useStore();

	const [disabled, setDisabled] = useState(true);
	const [, updateState] = useState();
	const forceUpdate = useCallback(() => updateState({}), []);


	// check for valid form values then accordingly make save button disable / enable
	const handleChange = debounce(() => {
		form
			.validateFields()
			.then((d) => {
				setDisabled(false);
			})
			.catch((d) => {
				setDisabled(true);
			});
		forceUpdate();
	}, 500);


	// Handle submit and call function to save new record
	const handleSubmit = (data, redirect = false) => {
		if (!data.product_base) {
			data.product_base = 10
		}
		InsuranceProductStore.addInsuranceProduct(data).then((data) => {
			vsmNotify.success({
				message: data.STATUS.NOTIFICATION[0],
			});
			if (redirect) {
				props.close();
				openSelectAddOnModal();
			}
			else {
				close();
			}
		}).catch((e) => {
			// console.log("error......", e);
			if (e.errors) {
				form.setFields(convertError(e.errors));
			}
		})
			.finally(() => setSaving(false));
	};

	// reset form and close add form
	const close = () => {
		form.resetFields();
		props.close();
		InsuranceProductStore.resetValues();
	};

	return (
		<Drawer
			className="addModal"
			title={`Create Insurance Product`}
			width="80%"
			visible={props.visible}
			closeIcon={<FontAwesomeIcon icon={faTimes} />}
			onClose={close}
			footer={[
				<Button
					key="2"
					htmlType="button"
					className="cancelBtn mr-35"
					onClick={close}
				>
					Cancel
				</Button>,
				tpInsurance.includes(form.getFieldValue("cat_id")) &&
				(<Button
					key="1"
					disabled={disabled}
					form="addInsuranceProduct"
					loading={saving}
					className="mr-35"
					htmlType="submit"
					type="primary"
				>
					Save
				</Button>),
				addonNormalInsurance.includes(form.getFieldValue("cat_id")) &&

				(<Button
					key="2"
					disabled={disabled}
					form="addInsuranceProduct"
					loading={saving}
					onClick={() => handleSubmit(form.getFieldsValue(), true)}
					type="primary"
				>
					Save & Select Add-Ons
				</Button>),
			]}
		>
			<InsuranceProductFormComponent
				form={form}
				setDisabled={setDisabled}
				handleChange={handleChange}
				initialValues={InsuranceProductStore.initialValues}
				handleSubmit={handleSubmit}
				id="addInsuranceProduct"
			/>
		</Drawer>
	);
});

export default AddComponent;
